// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1bEIr","col":"Table_col__-Y_NU","fulfillmentStatus":"Table_fulfillmentStatus__3Yn5h","emailCol":"Table_emailCol__2_XCY"};